import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React from "react";
import { connect } from "react-redux";
import { Route, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import Paper from "../../containers/Paper";
import TabPanel from "../../containers/TabPanel";
import SampleNewOnboarding from "./Onboarding";
import SampleregisterFilter from "./sampleRegisterfilter";

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface Props {}

const SampleRegister: React.FC<Props> = ({}) => {
  const { path, url, isExact} = useRouteMatch();
  const location = useLocation();
  const history = useHistory();
  const selectedTab = isExact? 0: 1;
  const isNew = isExact || location.pathname.startsWith(`${url}/new`);  
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    if (newValue === 0) {
      // Redirect to new location
      history.push(`${url}`);
    }else{
      history.push(`${url}/new`);
    }
  };

  return (
    <Paper>
      <AppBar position="static">
        <Tabs
          variant="fullWidth"
          value={selectedTab}
          onChange={handleChange}
          aria-label="simple tabs example"
          style={{ justifyContent: "space-around" }}
        >
          <Tab label="Samples Onboarding" {...a11yProps(0)} />
          <Tab label={isNew? "Onboard New Sample Registration" : "Edit Onboard Samples"} {...a11yProps(1)} />
        </Tabs>
      </AppBar>

      <TabPanel style={{ width: "100%" }} value={selectedTab} index={0}>
        <SampleregisterFilter />
      </TabPanel>
      <TabPanel style={{ width: "100%" }} value={selectedTab} index={1}>
        <Route path={`${path}/new`}>
          <SampleNewOnboarding />
        </Route>
        <Route
          path={`${path}/:projectId/:subProjectId`}>
          <SampleNewOnboarding /></Route>
      </TabPanel>
    </Paper>
  );
};
const mapStateToProps = () => ({});
export default connect(mapStateToProps, {})(SampleRegister);
